import React from 'react';
import Typography from '@material-ui/core/Typography';
import {CredentialResponse, GoogleLogin, GoogleOAuthProvider} from '@react-oauth/google';
import UserContext, {User} from '../common/UserContext';
import {decodeJwt} from 'jose';
import config from '../../ext/configuration';

function getUserInfo(jwt: string): User {
  const payload = decodeJwt(jwt) as Record<string, string> | undefined;

  if (!payload)
    throw new Error('Failed to get payload from ticket');

  return {
    emailAddress: payload.email || '',
    name: payload.name || '',
    picture: payload.picture || ''
  }
}

function createToken(googleToken: string): Promise<string|void> {
  return fetch('/api/v1/token', {
    method: 'POST',
    headers: {
      'Authorization': googleToken
    }
  }).then((response) => {
    if (response.ok) {
      return response.text();
    } else {
      throw new Error('Token creation failed');
    }
  }).catch((error) => {
    console.error('Error creating token: %o', error);
  });
}

const NotSignedIn: React.FC = () => {
  const userContext = React.useContext(UserContext);

  function handleOnSuccess(credential: CredentialResponse): void {
    if (credential.credential) {
      const user = getUserInfo(credential.credential);
      createToken(credential.credential)
        .then(token => {
          userContext.signIn(user, token || 'missing-token');
        });
    } else {
      // TODO: handle this error
      console.log('No credential returned');
    }
  }

  return (
    <GoogleOAuthProvider clientId={config.googleAppKey}>
      <Typography variant="h1">
        Sign in
      </Typography>
      <p>
        Sign in with your UCSB Google account to continue.
      </p>
      <GoogleLogin
        onSuccess={handleOnSuccess}
        onError={() => console.log('Error signing in')}
        shape='pill'
      />
    </GoogleOAuthProvider>
  );
};
export default NotSignedIn;
